import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Output,
    EventEmitter,
} from "@angular/core";

import { GlobalOccasionSection, GlobalOccasionEntry } from "../../data/model";
import { PersistenceService } from "../../store/model/persistence.service";
import { GlobalOccasionSectionValidity } from "../../store/validity/state";
import { LocalState } from "./global-occasion.component";
import { trackEntity } from "../../utils/utils";

@Component({
    selector: "zbd-global-occasion-section",
    templateUrl: "global-occasion-section.component.html",
    styleUrls: ["./global-occasion-section.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalOccasionSectionComponent {
    @Input() section: GlobalOccasionSection;

    @Input() persistence: PersistenceService;
    @Input() state: LocalState;
    @Input() validity: GlobalOccasionSectionValidity;

    @Output("delete-section") deleteSection =
        new EventEmitter<GlobalOccasionSection>();

    trackEntity = trackEntity;

    updatePriority() {
        return (
            section: GlobalOccasionEntry,
            property: keyof GlobalOccasionEntry,
            value: string,
        ) => {
            const parsedValue = value ? parseInt(value) : null;
            this.persistence.updateGlobalOccasionEntry(
                section,
                property,
                parsedValue,
            );
        };
    }

    updateConsultingRequested() {
        return (
            section: GlobalOccasionEntry,
            property: keyof GlobalOccasionEntry,
            value: string,
        ) => {
            const parsedValue = value ? value === "true" : null;
            this.persistence.updateGlobalOccasionEntry(
                section,
                property,
                parsedValue,
            );
        };
    }
}
